export default "__VITE_ASSET__c2f255c7__"